import { fetchAuthSession, signOut } from 'aws-amplify/auth';

import { API_URL } from '@/constants';
import { ApiResult, Method } from '@/types/api';
// 管理画面からAPIを呼び出す汎用関数
export const callApi = async <T>(
  path: string,
  method: Method,
  query?: URLSearchParams,
  body?: object,
  loginiUserEmail?: string,
  officeIDs?: number[],
  canRetry = false
): Promise<ApiResult<T>> => {
  let url = `${API_URL}/${path}`;
  console.log('callApi', url);
  if (query) {
    url = `${url}?${query.toString()}`;
  }
  const headers = new Headers();
  const token = localStorage.getItem('token');
  headers.append('Authorization', `${token}`);
  headers.append('Accept', 'application/json');

  // TODO: 事業所に紐づくデータを取得する場合に使っているが、メールアドレスに寄せたい
  if (officeIDs && officeIDs.length > 0) {
    headers.append('X-Office-Ids', officeIDs.join(','));
  }

  // ログインユーザーに紐づくデータを取得する場合、ログインユーザーのメールアドレスをヘッダーに追加
  if (loginiUserEmail) {
    headers.append('X-Email', loginiUserEmail);
  }

  if (method !== 'GET') {
    headers.append('Content-Type', 'application/json');
  }

  const params = {
    method,
    body: JSON.stringify(body),
    headers: headers,
  };

  try {
    const response = await fetch(url, params);
    const status = response.status;
    if (status === 401) {
      if (canRetry) {
        const session = await fetchAuthSession();
        const token = session?.tokens?.idToken?.toString();
        if (session) {
          if (token) {
            localStorage.setItem('token', token);
            return callApi(path, method, query, body, loginiUserEmail, officeIDs, false);
          }
        }
      }
      await signOut();
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      window.location.href = '/admin/login';
    }
    const result = await response.json();
    return { status, result };
  } catch (e) {
    console.error(e);
    return { status: 500, result: null as T };
  }
};

// LINEミニアプリからAPIを呼び出す汎用関数
export const callApiWithoutToken = async <T>(
  path: string,
  method: Method,
  lineAccessToken?: string,
  query?: URLSearchParams,
  body?: object
): Promise<ApiResult<T>> => {
  let url = `${API_URL}/${path}`;
  if (query) {
    url = `${url}?${query.toString()}`;
  }
  const headers = new Headers();
  const params = {
    method,
    body: JSON.stringify(body),
    headers: headers,
  };
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  if (lineAccessToken) {
    headers.append('x-line-access-token', lineAccessToken);
  }

  const response = await fetch(url, params);
  const status = response.status;
  if (status === 201 || status === 204) {
    return { status, result: null as T };
  }

  const result = await response.json();
  return { status, result };
};
